import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import {
    EditorInventoryRateCorrectionCondition,
    InventoryRateCorrectionType,
    RateControlValue,
    RateCorrectionConditionChooserItemsGroup,
    RateCorrectionConditionId,
    RateCorrectionType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';
import { RateCorrectionConditionChooserView } from '../../RateCorrectionConditionChooser/RateCorrectionConditionChooser';
import { RateCorrectionConditionSelector } from '../../RateCorrectionConditionSelector/RateCorrectionConditionSelector';

import './RatesCorrectionsListInventoryCondition.css';

export type onChangeInventoryConditionParams = {
    type: RateCorrectionType.inventory;
    value: EditorInventoryRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListInventoryConditionProps {
    value: EditorInventoryRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    isDisabled: boolean;
    chooserData: Array<RateCorrectionConditionChooserItemsGroup>;
    disabledChooserDataItems: Array<string>;
    isChooserDisabled: boolean;
    onChange: (params: onChangeInventoryConditionParams) => void;
}

const blockClass = 'rates-corrections-list-inventory-condition';

export const RatesCorrectionsListInventoryCondition = React.memo(
    (props: RatesCorrectionsListInventoryConditionProps) => {
        const value = useMemo(() => [props.value.inventoryType], [props.value.inventoryType]);
        const onChooserChange = useCallback(
            (values: Array<string>) => {
                props.onChange({
                    type: RateCorrectionType.inventory,
                    id: props.value.id,
                    value: {
                        ...props.value,
                        inventoryType: values[0] as InventoryRateCorrectionType
                    }
                });
            },
            [props.value]
        );
        const onRateControlChange = useCallback(
            (rate: RateControlValue) => {
                props.onChange({
                    type: RateCorrectionType.inventory,
                    id: props.value.id,
                    value: {
                        ...props.value,
                        value: rate
                    }
                });
            },
            [props.value]
        );

        return (
            <div className={blockClass}>
                <RateCorrectionConditionSelector
                    cls={Bem.cls(blockClass, 'selector')}
                    view={RateCorrectionConditionChooserView.default}
                    value={value}
                    isDisabled={props.isDisabled || props.isChooserDisabled}
                    items={props.chooserData}
                    disabledItems={props.disabledChooserDataItems}
                    onChange={onChooserChange}
                />

                <RateControl
                    value={props.value.value}
                    max={props.maxRate}
                    min={props.minRate}
                    isDisabled={props.isDisabled}
                    isCommon={false}
                    errors={props.value.errors.value}
                    onChange={onRateControlChange}
                />
            </div>
        );
    }
);
